module.exports = __webpack_public_path__ + "static/logo-ef44a8a591c680bc2f2cf6744769536b.png";